import api from "./api";
import { getRefreshToken } from "./auth";
import { headers } from "./config";

export default class LoginService {
	private resource = "";
	private instance = api;
	constructor() {
		this.resource = "token/";
	}

	async login(username: string, password: string) {
		try {
			const response = await api.post(this.resource, { username, password }, headers);
			return { success: response.data };
		} catch (err) {
			return { error: "usuário ou senha incorreto." };
		}
	}

	async refreshToken() {
		const response = await api.post(`${this.resource}refresh/`, { refresh: getRefreshToken() }, headers);
		localStorage.setItem("token", response.data.access);
		return response.data;
	}
}
